import { StyledWidget, StyledButton } from '@/components/styles';
import { Appointment } from '@/components';
import { useEffect, useState, useRef } from 'react';
import Icon from '@/assets/icons';
import { phones, socialContacts, email } from '@/lib/config';
import { useTranslation } from 'react-i18next';

export default function ContactWidget({ buttonAppearance = false, fixed = true }) {
  const [opened, setOpened] = useState(false);
  const ref = useRef(null);
  const { t } = useTranslation('global');

  useEffect(() => {
    const handleClick = (event) => {
      const classList = event.target.classList;
      if (classList.contains('modal-underlay') || (classList.contains('modal__close') && opened)) {
        setOpened(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [opened]);
  return (
    <StyledWidget ref={ref} static={!fixed}>
      {buttonAppearance ? (
        <StyledButton onClick={() => setOpened(!opened)}>{t('contactUs')}</StyledButton>
      ) : (
        <StyledWidget.Button type="button" onClick={() => setOpened(!opened)}>
          {!opened && <Icon name="phone-big" width={30} height={30} />}
          {opened && <Icon name="close" width={19} height={20} />}
        </StyledWidget.Button>
      )}
      {opened && (
        <StyledWidget.Body under={buttonAppearance}>
          <StyledWidget.Section>
            <StyledWidget.Title>{t('contacts.call')}</StyledWidget.Title>
            {phones.map((phone, ind) => {
              const { title, href, icon } = phone;
              return (
                <StyledWidget.Item key={ind} href={href}>
                  <Icon name={icon} width={20} height={20} stroke="#B69B64" />
                  {title}
                </StyledWidget.Item>
              );
            })}
          </StyledWidget.Section>

          <StyledWidget.Section>
            <StyledWidget.Title>{t('contacts.write')}</StyledWidget.Title>
            <StyledWidget.Item href={email.href}>
              <Icon name={email.icon} width={20} height={20} stroke="#B69B64" />
              {email.title}
            </StyledWidget.Item>
            {socialContacts.map((social, ind) => {
              const { name, icon, href } = social;
              return (
                <StyledWidget.Item key={ind} href={href} target="_blank" rel="noopener noreferrer">
                  <Icon name={icon} width={20} height={20} />
                  {name}
                </StyledWidget.Item>
              );
            })}
          </StyledWidget.Section>
          <StyledWidget.Section>
            <Appointment render={AppointmentBtn} />
          </StyledWidget.Section>
        </StyledWidget.Body>
      )}
    </StyledWidget>
  );
}

function AppointmentBtn(props) {
  const { t } = useTranslation('global');
  return (
    <StyledWidget.AppointButton type="button" {...props}>
      {t('bookAppointment')}
    </StyledWidget.AppointButton>
  );
}
